import React from "react";

import Flex from "../../../../components/Flex/Flex";

import ProductionStatusLadderStep from "./components/ProductionStatusLadderStep";
import useProductionStatusLadderSteps from "./hooks/useProductionStatusLadderSteps";

export default function ProductionStatusLadder({ production }) {
	const steps = useProductionStatusLadderSteps({ production }).filter((step) => !step.hidden);

	const activeStep = [...steps].reverse().find((step) => step.active);

	const activeNumber = steps.indexOf(activeStep) + 1;

	return (
		<Flex justifyContent="flex-start">
			{steps.map((step, index) => {
				return (
					<ProductionStatusLadderStep
						key={index}
						step={step}
						number={index + 1}
						activeNumber={activeNumber}
						last={index === steps.length - 1}
					/>
				);
			})}
		</Flex>
	);
}
